<template>
	<div style="height: 100%;">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'UserMonitor',
		components: {},
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
